import React from 'react';
import { Link } from 'react-router-dom';
import { Car, Phone, MapPin, Envelope, DownloadSimple } from '@phosphor-icons/react';
import { QRCodeSVG } from 'qrcode.react';

const APP_URL = 'https://trouvermapiece.fr';

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#E63946] flex items-center justify-center">
                <Car size={24} weight="bold" className="text-white" />
              </div>
              <span className="font-['Outfit'] text-xl font-bold tracking-tight text-white">
                ECOCASSE
              </span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Spécialiste des pièces automobiles d'occasion garanties. 
              Notre logiciel d'analyse vous aide à identifier rapidement 
              les pièces potentiellement endommagées sur votre véhicule.
            </p>
          </div>

          <div>
            <h4 className="font-['Outfit'] text-sm uppercase tracking-[0.2em] text-gray-500 mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/analyse" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Analyser mon véhicule
                </Link>
              </li>
              <li>
                <a href="https://ecocasse.fr" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors">
                  Boutique Ecocasse
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Outfit'] text-sm uppercase tracking-[0.2em] text-gray-500 mb-4">
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Phone size={16} className="text-[#E63946]" />
                <span>03 88 66 13 38</span>
              </li>
              <li className="flex items-center gap-3 text-gray-400 text-sm">
                <Envelope size={16} className="text-[#E63946]" />
                <span>ecocasse@ecocasse.fr</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400 text-sm">
                <MapPin size={16} className="text-[#E63946] mt-0.5" />
                <span>Strasbourg, France</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Outfit'] text-sm uppercase tracking-[0.2em] text-gray-500 mb-4">
              Agréments
            </h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>N° d'agrément PR67 00010D</li>
              <li>ICPE 2712 VHU</li>
              <li>Arrêté Préfectoral complémentaire du 29/12/2017</li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Outfit'] text-sm uppercase tracking-[0.2em] text-gray-500 mb-4">
              Application
            </h4>
            <div className="bg-white p-3 rounded-lg inline-block" data-testid="qr-code-install">
              <QRCodeSVG
                value={APP_URL}
                size={110}
                level="M"
                fgColor="#1a1a1a"
                bgColor="#ffffff"
              />
            </div>
            <p className="text-gray-500 text-xs mt-3 leading-relaxed">
              Scannez pour installer<br />l'application sur votre mobile
            </p>
            <div className="flex items-center gap-1.5 mt-2 text-[#E63946] text-xs font-semibold">
              <DownloadSimple size={12} weight="bold" />
              <span>TrouverMaPiece</span>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-xs">
            © {new Date().getFullYear()} Ecocasse. Tous droits réservés.
          </p>
          <div className="flex flex-wrap justify-center md:justify-end gap-x-6 gap-y-2">
            <Link to="/mentions-legales" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-testid="footer-mentions-legales">
              Mentions légales
            </Link>
            <Link to="/politique-confidentialite" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-testid="footer-confidentialite">
              Politique de confidentialité
            </Link>
            <Link to="/politique-cookies" className="text-gray-500 hover:text-gray-300 text-xs transition-colors" data-testid="footer-cookies">
              Gestion des cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
